import {requestStores} from '../../ListOfPREditors.brick.jsx';
import {useFieldEditability} from '../utils/useFieldEditability.js';
import React from 'react';
import {Divider, Typography} from '@mui/material';
import {PRFileUpload} from '../utils/PRFileUpload.jsx';
import {AttachmentsTable} from './AttachmentsTable.jsx';
import {Attachment} from '../../../models/attachments_info/Attachment';
import PropTypes from 'prop-types';
import {BrickContext} from 'olympe';

/**
 * @param {OptionalDocuments.propTypes} props
 * @return {JSX.Element}
 */
export function OptionalDocuments(props) {
    const useRequestStore = requestStores.get(props.prTag);

    const createMainAttachment = useRequestStore((state) => state.createMainAttachment);
    const {isDisabled} = useFieldEditability(props.prTag, {context: props.context});

    const handleUploadMainAttachments = (attachment, resetInput) => {
        if (resetInput && typeof resetInput === 'function') {
            resetInput();
        }

        createMainAttachment(new Attachment(attachment.tag, 'Specification', attachment.user, attachment.date, attachment.name, attachment.userId));
    };

    return (
        <>
            <Typography variant="h6" sx={{marginBottom: '1rem', color: 'rgb(75,66,70)'}}>Optional Documents (e.g. Project briefs, Technical Drawings, etc.)</Typography>
            <PRFileUpload
                onFileUploaded={(att, resetInput) => {
                    handleUploadMainAttachments(att, resetInput);
                }}
                persistFiles={true}
                disabled={isDisabled('attachments.optionalUpload')}
            />
            <div style={{margin: '1rem'}}></div>
            <AttachmentsTable
                prTag={props.prTag}
                context={props.context}
                attachmentsType={'main'}
                from='expandedPr'
                disabled={isDisabled('attachments.optionalTable')}
            />
            <Divider className={'pr-editor-attachments-horizontal-separator'} />
        </>
    );
}

OptionalDocuments.propTypes = {
    prTag: PropTypes.string,
    context: PropTypes.instanceOf(BrickContext).isRequired,
};
